module.exports = __webpack_public_path__ + "img/7.63c06fb8.png";